import { useState, useMemo } from "react";
import { useDispatch } from "react-redux";
import { withTranslation } from 'react-i18next';
import useParamSelector from "../data/useParamSelector";

import { 
  encodeBitMask, 
  decodeBitMask, 
} 
from "../utility/hexEncoding";

import { 
  currentSettingsSet,
  selectCurrentComponentDesc,
  selectComponentValueObject
} from "../data/devicesSlice";

import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Stack,
  Switch,
} from '@mui/material/';
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';
import NotificationsOffOutlinedIcon from '@mui/icons-material/NotificationsOffOutlined';
import { 
  HelpText 
} from "./ReadMore";

function PureNotificationToggleButton({ t, block }) {
  const dispatch = useDispatch();
  const disabled = block.disabled ?? false;
  const componentId = block.id;
  const data = useParamSelector(selectCurrentComponentDesc, componentId);
  const title = data.description.TITLE;
  const infoText = data.description.INFO_TEXT;
  const bitMask = parseInt(data.description.BIT_MASK,16);
  const intialComponentValue = useParamSelector(selectComponentValueObject, componentId) ?? false;
  // When mute is true, notification is off --> need to invert
  const switchValue = !decodeBitMask(intialComponentValue, bitMask);

  const handleChange = (event) => {
    const newValue = event.target.checked;
    // When mute is true, notification is off --> need to invert
    const value = encodeBitMask(intialComponentValue, bitMask, !newValue);
    const dbSettings = {
      value,
      dbTarget: data.dbTarget,
    }
    dispatch(currentSettingsSet({dbSettings, bitMask}));
  };

  const switchIcon = switchValue 
  ? <NotificationsActiveOutlinedIcon color="success" /> 
  : <NotificationsOffOutlinedIcon color="warning" />;

  return (
    <FormControl sx={{ml:2}}>
      {!!title && <FormLabel>{t(title)} <HelpText text={t(infoText)} /></FormLabel>}
      <FormControlLabel
        control={
          <Switch 
            checked={switchValue}
            onChange={handleChange}
            disabled={disabled}
          />
        }
        label={<>{switchIcon} </>}
        />
    </FormControl>
  );

};

const NotificationToggleButton = withTranslation()(PureNotificationToggleButton);

export {
  NotificationToggleButton
};